import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import Client from './client';

type Response = Awaited<ReturnType<typeof Client.fetchParkinglotBySerialCode>>;

const select = (response: Response) => {
  return response.data.data;
};

export const useParkingLotByCode = (
  {
    parkinglotCode,
    serialCode,
  }: { parkinglotCode?: string; serialCode?: string } = {},
  options: Omit<UseQueryOptions<Response>, 'queryFn' | 'queryKey'> = {},
) => {
  const { data, ...query } = useQuery({
    ...options,
    queryKey: ['partkinglot', 'from_serial_code', serialCode],
    queryFn: () =>
      Client.fetchParkinglotBySerialCode({ parkinglotCode, serialCode }),
    refetchInterval: false,
    select,
  });

  return { ...query, parkingLot: data };
};
